import Swiper from 'swiper';
import { AlpineComponent } from 'alpinejs';
import { Navigation } from 'swiper/modules';

export default (): AlpineComponent => ({
    init(): void {
        const swiperElement = this.$el.getElementsByClassName('swiper');
        const swiper = new Swiper(swiperElement[0], {
            modules: [Navigation],
            slidesPerView: 1.7,
            spaceBetween: 32,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            mousewheel: true,
            keyboard: true,
            autoHeight: true,
            breakpoints: {
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 32,
                },
            },
        });
    },
});